import React from 'react';
import { Row, Col } from 'react-bootstrap'; 

import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTable from 'components/common/myAdvancedTable/AdvanceTable';
import AdvanceTableSearchBox from 'components/common/myAdvancedTable/AdvanceTableSearchBox';
import AdvanceTableFooter from 'components/common/myAdvancedTable/AdvanceTableFooter';

const MyAdvancedTable = ({
    columns,
    data,
    topButton = <></>,
    topButtonShow = false,
}) => {

    const AdvanceTableExample = () => {

        const table = useAdvanceTable({
            data,
            columns: columns.filter(col => !col.isHidden),
            sortable: true,
            pagination: true,
            perPage: window.__ENV__.TABLEAUX_LIGNES_DEFAUT
        });

        return(
            <AdvanceTableProvider {...table}>
                <Row className="flex-end-center mb-3">
                    <Col xs="auto" sm={6} lg={8}>
                        {topButtonShow == true ? <>{topButton}</> : null}
                    </Col>
                    <Col xs="auto" sm={6} lg={4}>
                        <AdvanceTableSearchBox />
                    </Col>
                </Row>
                <AdvanceTable
                    headerClassName="bg-200 text-nowrap align-middle"
                    rowClassName="align-middle white-space-nowrap"
                    tableProps={{
                    bordered: true,
                    striped: true,
                    className: 'fs-10 mb-0 overflow-hidden'
                    }}
                />
                <div className="mt-3">
                    <AdvanceTableFooter
                        rowInfo
                        navButtons
                        rowsPerPageSelection
                    />
                </div>
            </AdvanceTableProvider>
        )
    }
    return(<AdvanceTableExample />)
};

MyAdvancedTable.propTypes = {};

export default MyAdvancedTable;